import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable()
export class VpoVpogledHttpInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (req.url.startsWith('/api/') || req.url.startsWith('api/')) {
      return next.handle(req);
    }
    const baseUrl = '/api/vpo2327/vpogled';
    const apiReq = req.clone({
      url: `${baseUrl}/${req.url.charAt(0) === '/' ? req.url.slice(1) : req.url}`,
    });
    return next.handle(apiReq);
  }
}
